import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import { Box, Divider, CircularProgress, Snackbar, Alert } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faFileExcel,
  faFileCsv,
  faFilePdf,
  faChartBar,
  faFaceSmile,
} from "@fortawesome/free-solid-svg-icons";
import { reportsApi } from "../../../../API/axiosInstance";

const FONT = "'Host Grotesk', sans-serif";
const REPORT_TYPES = [
  {
    value: "section",
    label: "Section Analysis Report",
    icon: faChartBar,
    color: "#6366f1",
    bg: "#eef2ff",
    endpoint: "/socialmedia",
  },
  {
    value: "sentiment",
    label: "Sentiment Analysis Report",
    icon: faFaceSmile,
    color: "#10b981",
    bg: "#ecfdf5",
    endpoint: "/sentiment",
  },
];


const FORMATS = [
  {
    value: "excel",
    label: "Excel",
    ext: ".xlsx",
    icon: faFileExcel,
    color: "#16a34a",
    bg: "#f0fdf4",
    mimeType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  {
    value: "csv",
    label: "CSV",
    ext: ".csv",
    icon: faFileCsv,
    color: "#0891b2",
    bg: "#ecfeff",
    mimeType: "text/csv",
  },
  {
    value: "pdf",
    label: "PDF",
    ext: ".pdf",
    icon: faFilePdf,
    color: "#dc2626",
    bg: "#fef2f2",
    mimeType: "application/pdf",
  },
];


function DownloadManagerDialog({ open, onClose, onDownload, session, currentTab }) {

  // const [reportType, setReportType] = React.useState("section");
  const [reportType, setReportType] = React.useState(
    currentTab === "sentiment" ? "sentiment" : "section"
  );


  const [format, setFormat] = React.useState("pdf");
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });


  // const handleDownload = async () => {
  //   const selectedReport = REPORT_TYPES.find((r) => r.value === reportType);
  //   const selectedFormat = FORMATS.find((f) => f.value === format);
  //   if (!session) {
  //     setSnackbar({
  //       open: true,
  //       message: "No session ID available.",
  //       severity: "error",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const url = `${API_BASE_URL}${selectedReport.endpoint}`;


  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: selectedFormat.mimeType,
  //       },
  //       body: JSON.stringify({
  //         sessionId: session,
  //         filetype: format,
  //         type: reportType,
  //       }),
  //     });

  //     if (!response.ok) {
  //       const errorText = await response.text().catch(() => "");
  //       throw new Error(
  //         errorText || `Download failed (status ${response.status})`,
  //       );
  //     }

  //     // Get the blob from the response
  //     const blob = await response.blob();

  //     // Create a download link and trigger it
  //     const downloadUrl = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = downloadUrl;

  //     // Build filename from report type, session, and format
  //     const filename = `${selectedReport.label.replace(/\s+/g, "_")}_Session_${session}${selectedFormat.ext}`;
  //     link.setAttribute("download", filename);

  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(downloadUrl);

  //     setSnackbar({
  //       open: true,
  //       message: "Report downloaded successfully!",
  //       severity: "success",
  //     });

  //     // Notify parent if callback provided
  //     if (onDownload) onDownload({ reportType, format, session });

  //     onClose();
  //   } catch (error) {
  //     console.error("Download error:", error);
  //     setSnackbar({
  //       open: true,
  //       message:
  //         error.message || "Failed to download report. Please try again.",
  //       severity: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  React.useEffect(() => {
    setReportType(currentTab === "sentiment" ? "sentiment" : "section");
  }, [currentTab]);



  const filteredReportTypes =
    currentTab === "sentiment"
      ? REPORT_TYPES.filter((r) => r.value === "sentiment")
      : REPORT_TYPES.filter((r) => r.value === "section");




  const handleDownload = async () => {
    const selectedReport = REPORT_TYPES.find((r) => r.value === reportType);
    const selectedFormat = FORMATS.find((f) => f.value === format);

    if (!session) {
      setSnackbar({
        open: true,
        message: "No session ID available.",
        severity: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await reportsApi.post(
        selectedReport.endpoint,
        {
          sessionId: session,
          filetype: format,
          type: reportType,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: selectedFormat.mimeType,
          },
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"] || selectedFormat.mimeType;
      const blob = new Blob([response.data], { type: contentType });

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;

      const filename = `CSMART_${selectedReport.label.replace(/\s+/g, "_")}_Session_${session}.${selectedFormat.ext}`;

      link.setAttribute("download", filename);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      setSnackbar({
        open: true,
        message: "Report downloaded successfully!",
        severity: "success",
      });

      if (onDownload) onDownload({ reportType, format, session });

      onClose();
    } 
    
    
     catch (error) {
      console.error("Download error:", error);

      let errorMsg = "Failed to download report. Please try again.";

      if (error.response) {
        // Since responseType is 'blob', error response data is also a Blob
        if (error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const parsed = JSON.parse(text);
            errorMsg = parsed.message || parsed.error || text;
          } catch {
            // If not JSON, use the raw text
            try {
              errorMsg = await error.response.data.text();
            } catch {
              errorMsg = `Download failed (status ${error.response.status})`;
            }
          }
        } else if (typeof error.response.data === "string") {
          errorMsg = error.response.data;
        } else if (error.response.data?.message) {
          errorMsg = error.response.data.message;
        }
      } else if (error.message) {
        errorMsg = error.message;
      }

      setSnackbar({
        open: true,
        message: errorMsg,
        severity: "error",
      });


    } 
    
    finally {
      setLoading(false);
    }
  };




  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };





  const RadioCard = ({ option, selected, onChange }) => (
    <Box
      onClick={() => !loading && onChange(option.value)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 14px",
        borderRadius: "10px",
        border: `1.5px solid ${selected === option.value ? option.color : "#e2e8f0"}`,
        background: selected === option.value ? option.bg : "#fafafa",
        cursor: loading ? "not-allowed" : "pointer",
        opacity: loading ? 0.6 : 1,
        transition: "all 0.18s ease",
        mb: 1,
        "&:hover": {
          borderColor: loading ? undefined : option.color,
          background: loading ? undefined : option.bg,
        },
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: "8px",
          background: selected === option.value ? option.color : "#f1f5f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "all 0.18s ease",
        }}
      >
        <FontAwesomeIcon
          icon={option.icon}
          style={{
            fontSize: "14px",
            color: selected === option.value ? "#fff" : option.color,
          }}
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontFamily: FONT,
            fontSize: "12.5px",
            fontWeight: 600,
            color: selected === option.value ? option.color : "#374151",
            lineHeight: 1.3,
          }}
        >
          {option.label}
        </Typography>
        {option.ext && (
          <Typography
            sx={{
              fontFamily: FONT,
              fontSize: "11px",
              color: "#94a3b8",
              mt: "2px",
            }}
          >
            {option.ext}
          </Typography>
        )}
      </Box>
      <Radio
        checked={selected === option.value}
        onChange={() => onChange(option.value)}
        size="small"
        disabled={loading}
        sx={{
          color: "#cbd5e1",
          "&.Mui-checked": { color: option.color },
          p: "2px",
        }}
      />
    </Box>
  );


  return (
    <>
      <Dialog
        open={open}
        onClose={loading ? undefined : onClose}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            fontFamily: FONT,
            width: 520,
            maxWidth: "95vw",
            boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "18px 24px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "10px",
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FontAwesomeIcon
              icon={faDownload}
              style={{ fontSize: "16px", color: "#fff" }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: FONT,
                fontSize: "15px",
                fontWeight: 700,
                color: "#fff",
                lineHeight: 1.2,
              }}
            >
              Download Manager
            </Typography>
            <Typography
              sx={{
                fontFamily: FONT,
                fontSize: "11.5px",
                color: "rgba(255,255,255,0.75)",
                mt: "2px",
              }}
            >
              {session ? `Session #${session}` : "Select export options"}
            </Typography>
          </Box>
        </Box>

        {/* Body */}
        <DialogContent sx={{ padding: "20px 24px", pb: 0 }}>
          <Box sx={{ display: "flex", gap: "20px" }}>
            {/* Left — Report Type */}
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: FONT,
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#94a3b8",
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  mb: "10px",
                }}
              >
                Report Type
              </Typography>
              {filteredReportTypes.map((opt) => (
                <RadioCard
                  key={opt.value}
                  option={opt}
                  selected={reportType}
                  onChange={setReportType}
                />
              ))}
            </Box>

            {/* Divider */}
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "#f1f5f9" }}
            />

            {/* Right — Format */}
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: FONT,
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#94a3b8",
                  letterSpacing: "0.6px",
                  textTransform: "uppercase",
                  mb: "10px",
                }}
              >
                Select Format
              </Typography>
              {FORMATS.map((opt) => (
                <RadioCard
                  key={opt.value}
                  option={opt}
                  selected={format}
                  onChange={setFormat}
                />
              ))}
            </Box>
          </Box>
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            padding: "16px 24px",
            gap: "8px",
            borderTop: "1px solid #f1f5f9",
            mt: "16px",
          }}
        >
          <Button
            onClick={onClose}
            disabled={loading}
            sx={{
              fontFamily: FONT,
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "none",
              color: "#64748b",
              borderRadius: "10px",
              padding: "8px 18px",
              border: "1.5px solid #e2e8f0",
              "&:hover": { background: "#f8fafc", borderColor: "#cbd5e1" },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDownload}
            disabled={loading}
            sx={{
              fontFamily: FONT,
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "10px",
              padding: "8px 22px",
              minWidth: 120,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              boxShadow: "0 4px 14px rgba(102,126,234,0.35)",
              "&:hover": {
                background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                boxShadow: "0 6px 20px rgba(102,126,234,0.45)",
                transform: "translateY(-1px)",
              },
              "&:active": { transform: "translateY(0)" },
              "&.Mui-disabled": {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                opacity: 0.7,
                color: "#fff",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faDownload}
                  style={{ fontSize: "12px", marginRight: "7px" }}
                />
                Download
              </>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for success/error feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%", fontFamily: FONT }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}


DownloadManagerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func,

  session: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentTab: PropTypes.string,

};

export default DownloadManagerDialog;
